// Core 
import { useState, useCallback, useRef, useEffect } from 'react';
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { SiCrystal } from 'react-icons/si';
import { FaStar } from 'react-icons/fa6';
import WebApp from '@twa-dev/sdk';

// Assets
import { textLang } from 'services/Lang';
import { apiService } from 'services/ApiService';

// Components
import ErrorCard from 'components/Form/Errors';

const PackageItem = ({name, desc, crystals, stars, bg, borderBottom, packId, setLoadingPack, setErrorCard, onClose}) => {
  const history = useHistory();
  /*const createInvoice = useCallback(async () => {
    setLoadingPack(true);
    try {
      const response = await apiService.createInvoice({ packId });
      setLoadingPack(false);
      WebApp.openInvoice(response.data.invoiceLink, async (status) => {
        if (status === 'paid') {
          await apiService.confirmInvoice({packId, invoiceId: response.data.invoiceId});
          onClose();  
          history.push('/'); 
        } if (status === 'cancelled') {
          await apiService.cancelledInvoice({invoiceId: response.data.invoiceId});
        } else {
          setErrorCard(status);
        }
      });

    } catch (e){}
  });*/

  const createInvoice = useCallback(async () => {
    setLoadingPack(true);
    try {
      setLoadingPack(true);
      await apiService.createInvoice({ packId });
      setLoadingPack(false);
      alert(textLang('pay_alert'));
    } catch (e) {
      setLoadingPack(false);
      console.error(e);
    }
  });

  /*const createInvoice = async (packId) => {
    try {
      setLoadingPack(true);
      await apiService.createInvoice({ packId });
      setLoadingPack(false);
      alert(textLang('pay_alert'));
    } catch (e) {
      setLoadingPack(false);
      console.error(e);
    }
  };*/

  return (
      <Box 
        mt="8px" 
        bg={bg} 
        overflow="visible !important" 
        position="relative"
        borderRadius="12px" 
        onClick={createInvoice}
        borderBottom={borderBottom}
        p="16px 8px">
        
        <Box>
          <Text variant="title-lg">{name}</Text>
          <Flex gap="4px" alignItems="center" w="100%" mt="8px">
            <SiCrystal fontSize="24px" color="#0088cc" />
            <Text variant="title-lg" fontSize="32px" fontWeight="900" color="#0088cc">{crystals}</Text>
          </Flex>
          <Text variant="text-sm">{desc}</Text>
        </Box>

        <Box w="100%" overflow="visible !important" position="absolute" top="10px" w="120px" right="8px">
          <Flex
            justifyContent="center"
            gap="4px"
            overflow="visible !important"
            bg="white"
            //border="2px solid #d6d6d6"
            borderRadius="30px"
            color="#FADA52"
            padding="5px 0px"
            //boxShadow="1px 1px 11px 1px #00000045"
            alignItems="center">
            <FaStar fontSize="18px" />
            <Text variant="title-sm">{stars}</Text>
          </Flex>
        </Box>

      </Box>
  );
};

const PackagesModal = ({onOpen, isOpen, onClose, userData}) => {
  const [loadingPack, setLoadingPack] = useState(false);
  const [errorCard, setErrorCard] = useState();

  const history = useHistory();
  const handleGoToWallet = async () => {
    onClose();  
    history.push('/profile/balance'); 
  };

  return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple modal__package" 
              maxW={{ base: 'calc(100% - 25px)' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
              <ModalCloseButton style={{zIndex: 999}} />
              <Box position="relative" p="80px 16px 70px 16px" bg='white !important' overflow="visible !important" textAlign="left">
                <Text variant="title-lg" mb="16px">{textLang('balance_top_up_header')}</Text>

                {/*<Text variant="title-lg" fontSize="32px" fontWeight="900">{textLang('coming_soon')}</Text>
                <Text variant="title-lg" px="10%" mt="12px">{textLang('balance_top_up_text')}</Text>*/}

                { errorCard && <ErrorCard error={errorCard} mt="24px" /> }

                <Box
                  opacity={loadingPack || errorCard ? '0.3' : '1'}
                  pointerEvents={loadingPack || errorCard ? 'none' : 'unset'}
                >
                  <PackageItem 
                    name="Mini Pack" 
                    desc={textLang('mini_pack')}
                    crystals="50"
                    packId={0}
                    setLoadingPack={setLoadingPack}
                    setErrorCard={setErrorCard}
                    onClose={onClose}
                    stars="50 stars"
                    bg="#bbbbbb"
                    borderBottom="5px solid #646464"
                  />

                  <PackageItem 
                    name="Starter Pack" 
                    desc={textLang('starter_pack')}
                    crystals="1,000"
                    packId={1}
                    setLoadingPack={setLoadingPack}
                    setErrorCard={setErrorCard}
                    onClose={onClose}
                    stars="1k stars"
                    bg="#cde9dd"
                    borderBottom="5px solid #64b291"
                  />

                  <PackageItem 
                    name="Booster Pack" 
                    desc={textLang('booster_pack')}
                    crystals="5,000"
                    packId={2}
                    setLoadingPack={setLoadingPack}
                    setErrorCard={setErrorCard}
                    onClose={onClose}
                    stars="5k stars"
                    bg="#dbcde9"
                    borderBottom="5px solid #9a7cb9"
                  />

                  <PackageItem 
                    name="Power Pack" 
                    desc={textLang('power_pack')}
                    crystals="50,000"
                    packId={3}
                    setLoadingPack={setLoadingPack}
                    setErrorCard={setErrorCard}
                    onClose={onClose}
                    stars="50k stars"
                    bg="#e9e6cd"
                    borderBottom="5px solid #a19b66"
                  />

                  <PackageItem 
                    name="Mega Pack" 
                    desc={textLang('mega_pack')}
                    crystals="100,000"
                    packId={4}
                    setLoadingPack={setLoadingPack}
                    setErrorCard={setErrorCard}
                    onClose={onClose}
                    stars="100k stars"
                    bg="#e9cdcd"
                    borderBottom="5px solid #9a6767"
                  />
                </Box>
                  
              </Box>
          </ModalContent>
        </Modal> 
      </>
  );
};

export default PackagesModal;